import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/options/";

export class SaveOptionsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload = null;

    constructor(payload: any) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}
